import { render, staticRenderFns } from "./HistoricoEdicaoItemBemPermanenteList.vue?vue&type=template&id=2b1d8845"
import script from "./HistoricoEdicaoItemBemPermanenteList.vue?vue&type=script&lang=js"
export * from "./HistoricoEdicaoItemBemPermanenteList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports